<template>
  <div class="wrapper">
    <side-bar backgroundColor="blue" backgroundImage="../img/sidebar-4.jpg">
      <sidebar-link to="/admin/operations">
        <i class="nc-icon nc-attach-87"></i>
        <p>Operations</p>
      </sidebar-link>
      
      <sidebar-link to="/admin/accounts">
        <i class="nc-icon nc-single-02"></i>
        <p>Comptes</p>
      </sidebar-link>

      <sidebar-link to="/admin/companies">
        <i class="nc-icon nc-bank"></i>
        <p>Entités</p>
      </sidebar-link>

      <!--<sidebar-link to="/admin/companies2">
        <i class="nc-icon nc-bank"></i>
        <p>Sites</p>
      </sidebar-link>-->
      
      <sidebar-link to="/admin/settings">
        <i class="nc-icon nc-settings-gear-64"></i>
        <p>Paramètres</p>
      </sidebar-link> 

      
      <template slot="bottom-links">
        
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="css">

</style>
<script>
  import TopNavbar from './PPETopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
